module.exports = __webpack_public_path__ + "media/images/players/LEE_DANNY-a176cc689dd397b6d2b739b53d5e1691.png";